module.exports = __webpack_public_path__ + "static/media/completed.f61cf5f1.gif";